import React from "react";
import {
  getMovers,
  getStatusForCustomer,
  getStatusForDirectRequest,
  time_convert,
} from "../../../../ui_libs/Functions/functions";
import { ShowCompanies } from "./components";
import CompanyInfo from "./components/Company-Info/CompanyInfo";
import CompletedandWaiting from "./components/Completed-Waiting/CompletedandWaiting";
import LeaveFeedback from "./components/Leave-Feedback/LeaveFeedback";
import Pay from "./components/Pay/Pay";
import Track from "./components/Track/Track";
import EditRequestDropdown from "./components/Edit-Request-Dropdown/EditRequestDropdown";
// import SignatureCanvas from "react-signature-canvas";
import { useSnakbar } from "../../../../Context/Context-Snakbar/ContextSnackbar";
import { withRouter } from "react-router-dom";
function Reques(props) {
  const { fetchRequestDetails, DeleteRequest, AttachSignature, requestData } =
    props;
  const {
    id,
    s_time,
    move_type,
    s_date,
    total_discount,
    request_timeline_status,
    recommend_amount,
    customer_budget,
    final_amount,
    discount,
    request_type,
    payment_method,
    public_access_link,
  } = requestData.request;

  const { showErrorSnak } = useSnakbar();
  const signPad = React.useRef();

  const handleRetakeSignature = () => {
    signPad.current.clear();
  };

  const handleConfirmMove = () => {
    props.history.push("/sign-confirmation-letter/" + public_access_link);
    // if (signPad.current.isEmpty()) {
    //   showErrorSnak("Please take signature on sign-pad");
    //   return;
    // }

    // const signature = signPad.current.getCanvas().toDataURL("image/png");
    // AttachSignature(signature);
  };

  return (
    <div className="rounded-box">
      <div className="heading-wrapper black-bg text-center">
        <span>
          <h6 className="text-white">
            Request #{id} {/* market place request */}
            {!request_type && request_timeline_status < 7 && (
              <EditRequestDropdown DeleteRequest={DeleteRequest} />
            )}
            {/* Direct request */}
            {/* {request_type &&
              request_timeline_status <= 3 &&
              requestData.additional_status === 0 && (
                <EditRequestDropdown DeleteRequest={DeleteRequest} />
              )} */}
          </h6>
        </span>
      </div>
      {request_timeline_status === 1 && (
        <ShowCompanies
          fetchRequestDetails={fetchRequestDetails}
          requestData={props.requestData}
        />
      )}
      <div className="request-left-box p-3 p-sm-4">
        <div className="row">
          <div className="col-10">
            <div className="request-staus small-font-size">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
              </svg>{" "}
              {request_type
                ? requestData.additional_status === 0 &&
                  request_timeline_status === 3
                  ? "Pending request confirmation"
                  : getStatusForDirectRequest(request_timeline_status)
                : getStatusForCustomer(request_timeline_status)}
            </div>
          </div>
          <div className="col-2 text-right">
            {/* <a
              href=""
              className="small-text-bold red-color add-new-btn"
              data-toggle="modal"
              data-target="#cancel-request"
            >
              <span>
                <img src={editIconImage} />
              </span>
            </a> */}
          </div>
        </div>
        <div
          className={
            request_timeline_status === 0
              ? "bid-form-wrapper "
              : "bid-form-wrapper"
          }
        >
          <div className="row small-font-size pt-3">
            <div className="col-6 text-left dark-grey-color">Move Type:</div>
            <div className="col-6 text-right black-color">{move_type}</div>
          </div>
          <div className="row small-font-size pt-3">
            <div className="col-6 text-left dark-grey-color">Move Date:</div>
            <div className="col-6 text-right black-color">
              {/* {schedule_time.slice(0, 11)} */}
              {s_date}
            </div>
          </div>
          <div className="row small-font-size pt-3">
            <div className="col-6 text-left dark-grey-color">Move Time:</div>
            <div className="col-6 text-right black-color">
            {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
            {s_time && s_time !== "8AM - 12PM Morning" &&
                    s_time !== "12PM - 5PM Evening" &&
                    s_time !== "Entire day" &&
                    `${time_convert(
                      s_time.split('-')[0].trim()
                    )} to ${time_convert(s_time.split('-')[1].trim())}`}
                  {s_time && (s_time == "8AM - 12PM Morning" ||
                    s_time == "12PM - 5PM Evening" ||
                    s_time == "Entire day") && `${s_time}`}
            </div>
          </div>
          <div className="row small-font-size pt-3">
            <div className="col-6 text-left dark-grey-color">Movers:</div>
            <div className="col-6 text-right black-color">
              {getMovers(props.requestData)}
            </div>
          </div>
          {request_type && request_timeline_status >= 3 && (
            <>
              {/* Hourly rate details */}
              {requestData.request.rate_method === "Hourly" && (
                <>
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Cash Hour Rate:
                    </div>
                    <div className="col-6 text-right black-color">
                      ${requestData.request.cash_payment_rate}
                    </div>
                  </div>
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Card Hour Rate:
                    </div>
                    <div className="col-6 text-right black-color">
                      ${requestData.request.card_payment_rate}
                    </div>
                  </div>{" "}
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Minimum Hours:
                    </div>
                    <div className="col-6 text-right black-color">
                      {requestData.request.minimum_hours}
                    </div>
                  </div>
                </>
              )}
              {/* Flat rate details */}
              {requestData.request.rate_method === "Flat" && (
                <>
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Cash Flat Rate:
                    </div>
                    <div className="col-6 text-right black-color">
                      ${requestData.request.cash_min_flat_rate} - $
                      {requestData.request.cash_max_flat_rate}
                    </div>
                  </div>
                  <div className="row small-font-size pt-3">
                    <div className="col-6 text-left dark-grey-color">
                      Card Flat Rate:
                    </div>
                    <div className="col-6 text-right black-color">
                      ${requestData.request.card_min_flat_rate} - $
                      {requestData.request.card_max_flat_rate}
                    </div>
                  </div>
                </>
              )}
              {request_timeline_status === 3 &&
                requestData.additional_status === 0 && (
                  <div className="row small-font-size pt-3">
                    <div className="col-12 mt-4">
                      <button
                        className="custom-buton custom-buton-large w-100"
                        onClick={handleConfirmMove}
                      >
                        Confirm and proceed with the move
                      </button>
                    </div>
                  </div>
                )}
            </>
          )}
          {request_timeline_status < 3 && !request_type && (
            <>
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">
                  Estimated Price:
                </div>
                <div className="col-6 text-right black-color">
                  ${recommend_amount}
                </div>
              </div>
              <div className="row small-font-size pt-3">
                <div className="col-6 text-left dark-grey-color">
                  Your Price:
                </div>
                <div className="col-6 text-right black-color">
                  ${customer_budget}
                </div>
              </div>
            </>
          )}
          {request_type &&
            (request_timeline_status === 6 ||
              request_timeline_status === 7) && (
              <>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">
                    Payment Method:
                  </div>
                  <div className="col-6 text-right black-color">
                    {payment_method}
                  </div>
                </div>
                {total_discount && total_discount !== "0" && (
                  <>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Price:
                      </div>
                      <div className="col-6 text-right black-color">
                        ${Number(final_amount) + Number(total_discount)}
                      </div>
                    </div>
                    <div className="row small-font-size pt-3">
                      <div className="col-6 text-left dark-grey-color">
                        Discount:
                      </div>
                      <div className="col-6 text-right light-red-color">
                        ${total_discount}
                      </div>
                    </div>
                  </>
                )}
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">
                    Final Price:
                  </div>
                  <div className="col-6 text-right black-color">
                    ${final_amount}{" "}
                  </div>
                </div>
              </>
            )}

          {request_type &&
            total_discount &&
            total_discount !== "0" &&
            request_timeline_status === 8 && (
              <>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">Price:</div>
                  <div className="col-6 text-right black-color">
                    ${Number(final_amount) + Number(total_discount)}
                  </div>
                </div>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">
                    Discount:
                  </div>
                  <div className="col-6 text-right light-red-color">
                    ${total_discount}
                  </div>
                </div>
              </>
            )}
          {/* {!request_type && final_amount && (
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Final Price:
              </div>
              <div className="col-6 text-right black-color">
                ${final_amount}
              </div>
            </div>
          )} */}

          {request_timeline_status > 1 && !request_type && (
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Final Price:
              </div>
              <div className="col-6 text-right black-color">
                ${final_amount}{" "}
              </div>

              {/* Discount */}
              {parseInt(discount) > 0 && !request_type && (
                <>
                  <div className="col-6 text-left dark-grey-color pt-3">
                    Discount:
                  </div>
                  <div className="col-6 text-right black-color pt-3">
                    {discount}%{" "}
                  </div>
                  {/* discounted price */}
                  <div className="col-6 text-left dark-grey-color pt-3">
                    Discounted Price:
                  </div>
                  <div className="col-6 text-right black-color pt-3">
                    ${final_amount * (1 - parseInt(discount) / 100)}
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* {request_timeline_status === 1 && (
          <ShowCompanies
            fetchRequestDetails={fetchRequestDetails}
            requestData={props.requestData}
          />
        )} */}

        {request_timeline_status === 2 && (
          <Pay requestData={props.requestData} />
        )}

        {request_timeline_status > 3 && (
          <CompanyInfo requestData={props.requestData} />
        )}

        {request_timeline_status === 5 && <Track />}
        {request_timeline_status === 6 && <CompletedandWaiting />}
        {request_timeline_status === 7 && (
          <LeaveFeedback
            requestData={props.requestData}
            fetchRequestDetails={fetchRequestDetails}
          />
        )}
      </div>
    </div>
  );
}

export default withRouter(Reques);
